import React from 'react';

const About = React.lazy(() => import('../../components/pages/About'));

export const AboutRouter = () => <About />;
